import UserDatabases from '@Services/UserDatabases';
import Search from '@Services/Search';

/* eslint-disable no-use-before-define */
const MULTIPLIER = 5;
const COMPLETE_PERCENT = 100;
const SWITCH_THRESHOLD = 9;

export const calculatePercentage = (runningTime) => {
  if (runningTime < SWITCH_THRESHOLD) {
    return calculateQuickPercentage(runningTime);
  }
  return calculateLongPercentage(runningTime);
};

// Math.random() is used solely for cosmetic jitter on a UI progress bar — not security-sensitive.
// NOSONAR
export const calculateQuickPercentage = (runningTime) =>
  // eslint-disable-next-line sonarjs/pseudo-random
  Math.min(COMPLETE_PERCENT, Math.max(0, MULTIPLIER * runningTime - Math.floor(Math.random() * MULTIPLIER)));

export const calculateLongPercentage = (runningTime) => Math.floor((COMPLETE_PERCENT * runningTime) / (runningTime + SWITCH_THRESHOLD));

export const getTotalProgress = (runningTime) => calculatePercentage(runningTime);

export const checkIfAllSearchesFinished = (progressPercentage, cb) => {
  const isAllFinished = Object.keys(progressPercentage).every((dbId) => progressPercentage[dbId].finished);

  if (isAllFinished && cb) {
    cb();
  }
};

export const getCurrentDbName = (priorityWatcher) => {
  const dbId = priorityWatcher.getFirstNotLoaded().databaseId;
  return UserDatabases.getDbName(dbId);
};

export const cancelSearch = (searchId, requestId) => {
  Search.cancelSearch(searchId, requestId);
};
